<dbx-entry-skeleton>
  <div class="form-container" data-cy="forget-password-page">
    <div class="title">{{ 'forgetPassword.title' | translate }}</div>
    <div class="subtitle">{{ 'forgetPassword.subtitle' | translate }}</div>
    <form class="form" [formGroup]="form" (ngSubmit)="submit()">
      <div class="form-field">
        <mat-form-field class="field" floatLabel="always">
          <mat-label>{{ 'login.email' | translate }}</mat-label>
          <input
            id="username"
            type="email"
            name="username"
            data-cy="username"
            formControlName="username"
            placeholder="email@example.com"
            required
            matInput
            [errorStateMatcher]="errorStateMatcher"
            dbxFocus
          />
          @if (submitted() && username?.invalid) {
            <mat-error>
              @if (username?.hasError('required')) {
                {{ 'forgetPassword.errors.emailRequired' | translate }}
              } @else if (username?.hasError('email')) {
                {{ 'forgetPassword.errors.invalidEmail' | translate }}
              }
            </mat-error>
          }
        </mat-form-field>
      </div>

      <button mat-button type="button" class="full-width" [routerLink]="['/' + Paths.LOGIN_PATH]">
        {{ 'forgetPassword.backToLogin' | translate }}
      </button>

      <button mat-flat-button class="full-width" [disabled]="loading()" type="submit">
        <span class="loading-button-container">
          <span [style.visibility]="loading() ? 'hidden' : 'visible'">
            {{ 'forgetPassword.continue' | translate }}
          </span>
          @if (loading()) {
            <mat-spinner class="white" diameter="20" />
          }
        </span>
      </button>
    </form>
  </div>
</dbx-entry-skeleton>
